import { ServiceData } from '../service';
import db from '../index';
import { entityServiceFactory } from '../entityServiceFactory';

export interface LevelsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<LevelsServiceData>(db, 'levelsService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
